import { useState } from "react";
import { PageHero } from "../components/common/PageHero";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { Lightbox } from "../components/common/Lightbox";
import { GALLERY } from "../data/site";
import { useSiteData, useC, fileUrl } from "../context/SiteData";

const spanClass = {
  large: "col-span-2 row-span-2",
  wide: "col-span-2",
  tall: "row-span-2",
  small: "",
};

const SPANS = ["large", "tall", "small", "small", "wide", "tall", "small", "wide"];

const Galeri = () => {
  const [active, setActive] = useState(null);
  const { gallery, loaded } = useSiteData();
  const c = useC();
  const items = gallery === null
    ? null
    : gallery.length
      ? gallery.map((g, i) => ({ src: fileUrl(g.path), alt: g.alt, span: SPANS[i % SPANS.length] }))
      : loaded
        ? GALLERY
        : [];

  return (
    <>
      <PageHero
        title={c.ph_galeri_title}
        subtitle={c.ph_galeri_subtitle}
        desc={c.ph_galeri_desc}
      />
      <section data-testid="galeri-grid" className="section-y">
        <div className="container-x">
          <div className="grid auto-rows-[160px] grid-cols-2 gap-3 sm:auto-rows-[200px] sm:gap-4 lg:grid-cols-4 lg:auto-rows-[220px]">
            {items === null &&
              Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className={`animate-pulse bg-cream-200 ${i === 0 ? "col-span-2 row-span-2" : ""}`} data-testid={`gallery-skeleton-${i}`} />
              ))}
            {(items || []).map((g, i) => (
              <Reveal key={g.src} delay={Math.min(i * 0.05, 0.25)} className={spanClass[g.span]}>
                <button
                  onClick={() => setActive(i)}
                  data-testid={`gallery-item-${i}`}
                  className="group relative block h-full w-full overflow-hidden"
                  aria-label={`${g.alt} fotoğrafını büyüt`}
                >
                  <img
                    src={g.src}
                    alt={g.alt}
                    loading="lazy"
                    className="h-full w-full object-cover saturate-[0.92] transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.04] group-hover:saturate-100"
                  />
                  <span className="pointer-events-none absolute inset-0 flex items-end bg-ink-950/0 p-4 transition-colors duration-300 group-hover:bg-ink-950/35">
                    <span className="translate-y-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-cream-50 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                      {g.alt}
                    </span>
                  </span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Lightbox
        items={items || []}
        index={active}
        onClose={() => setActive(null)}
        onNav={(d) => setActive((a) => (a + d + (items || []).length) % (items || []).length)}
      />
      <FinalCta />
    </>
  );
};

export default Galeri;
